/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetGraphicsSceneRequest} from '@cash-web/protos/squareup/cash/taply/app/v1beta1/get_graphics_scene_app.pb'
import {GetGraphicsSceneResponse} from '@cash-web/protos/squareup/cash/taply/app/v1beta1/get_graphics_scene_app.pb'


export const getGraphicsScene = (request: GetGraphicsSceneRequest, options?: CashRequestOptions) => post<GetGraphicsSceneRequest, GetGraphicsSceneResponse>("/cash-app/taply/v1.0/get-graphics-scene", request, {...options, rejectOnError: true })